export const URL_WEB = process.env.NEXT_PUBLIC_WEB_URL ?? "";
